<template>
  <div class="c-activity-previewer flex-center">
    <PromotionPreviewer v-if="activityData?.activityPlace" :activity-data="activityData" />
    <div v-else class="no-data">请先选择活动位置</div>
  </div>
</template>

<script setup lang="ts">
import { computed, useCurrentAppInstance } from '@zto/zpage'

import PromotionPreviewer from './promotion/promotion-previewer.vue'

const props = withDefaults(
  defineProps<{
    activityData?: Record<string, any>
  }>(),
  {}
)

const app = useCurrentAppInstance()
</script>

<style lang="scss" scoped>
.c-activity-previewer {
}
</style>
